/* eslint-disable no-console */
import * as types from "./actionTypes";

const process404Error = (props) => ({
  type: types.HTTP_404_ERROR,
  props,
});

const process500Error = (props) => ({
  type: types.HTTP_500_ERROR,
  props,
});

const processOtherError = (error) => ({
  type: types.HTTP_OTHER_ERROR,
  error,
});

export default (axiosError, props) => {
  if (axiosError == null || axiosError.response == null) {
    return processOtherError(axiosError);
  }

  try {
    const {
      response: { status },
    } = axiosError;

    if (status === 404) {
      return process404Error(props);
    }

    if (status === 500) {
      return process500Error(props);
    }

    return processOtherError(axiosError);
  } catch (err) {
    return processOtherError(axiosError);
    // create action type for unknown errors
  }
};
